import React, { useState } from "react";
import { connect } from "react-redux";
import { Drawer, Divider, Col, Row, Button, message, Popconfirm, Table, Tag } from "antd";
import { Link } from "react-router-dom";
import { deleteContact } from "../../../actions/contactAction";
import { getWordrobeByContact } from "../../../actions/wordrobe";
import EditContact from "./EditContact";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

const ContactDetails = ({
  details,
  deleteContact,
  setUpdatelist,
  updatelist,
  Auth,
  getWordrobeByContact,
}) => {
  const [visible, setVisible] = useState(false);
  const [wordrobes, setWordrobes] = useState([]);
  const [loadingWordrobes, setLoadingWordrobes] = useState(false);

  React.useEffect(() => {
    if (visible && details.id) {
      setLoadingWordrobes(true);
      getWordrobeByContact(details.id).then((res) => {
        if (res && res.results) {
          setWordrobes(res.results);
        } else if (res && Array.isArray(res)) {
          setWordrobes(res);
        }
        setLoadingWordrobes(false);
      });
    }
  }, [visible, details.id, getWordrobeByContact]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const confirm = () => {
    deleteContact(details.id).then((e) => {
      setVisible(false);
      setUpdatelist(!updatelist);
      message.success(
        details.name + " Has been deleted from your contact list"
      );
    });
  };

  return (
    <>
      <Link to="#" onClick={showDrawer} key={details.id}>
        View Profile
      </Link>

      <Drawer
        width={640}
        placement="right"
        closable={true}
        onClose={onClose}
        visible={visible}
      >
        <p
          className="site-description-item-profile-p"
          style={{ marginBottom: 24 }}
        >
          Information
        </p>
        <p className="site-description-item-profile-p">Personal</p>
        <Row>
          <Col span={12}>
            <DescriptionItem title="Name" content={details.name} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Phone" content={details.phone} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DescriptionItem title="Email" content={details.email} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Type" content={details.Role} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <DescriptionItem title="Address" content={details.address} />
          </Col>
          <Col span={24}>
            <div className="site-description-item-profile-wrapper">
              <p className="site-description-item-profile-p-label">Remarks:</p>
              <div dangerouslySetInnerHTML={{ __html: details.remarks }}></div>
            </div>
          </Col>
        </Row>
        <div style={{ marginTop: "20px" }}>
          {Auth.superuser ? (
            <Button danger style={{ marginRight: "10px" }}>
              <Popconfirm
                title="Are you sure to delete this contact?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
              >
                <Link to="#">Delete</Link>
              </Popconfirm>
            </Button>
          ) : (
            <></>
          )}
          <EditContact
            details={details}
            setUpdatelist={setUpdatelist}
            updatelist={updatelist}
          />
        </div>
        
        <Divider />
        <p className="site-description-item-profile-p">Sponsorship history</p>
        <Table
          dataSource={wordrobes}
          loading={loadingWordrobes}
          rowKey="id"
          size="small"
          pagination={false}
          columns={[
            { title: "Order No", dataIndex: "wordrobe_number", key: "wordrobe_number" },
            { title: "Location", dataIndex: "Location_name",align: "center", key: "Location_name" },
            { title: "Total Items", dataIndex: "total_items",align: "center", key: "total_items" },
            { title: "Total Qty", dataIndex: "total_quantity",align: "center", key: "total_quantity" },
            { title: "Returned Qty", dataIndex: "total_returned_quantity",align: "center", key: "total_returned_quantity" },
            {
              title: "Status",
              dataIndex: "",
              key: "is_returned",
              align: "center",
              render: (details) => {
                return (
                  <>
                    {!details.is_returned ? (
                      <Tag color="red" key={details.is_returned}>
                        {"Pending".toUpperCase()}
                      </Tag>
                    ) : (
                      <Tag color="green" key={details.is_returned}>
                        {"Returned".toUpperCase()}
                      </Tag>
                    )}
                  </>
                );
              },
            },
          ]}
        />

        
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  deleteContact,
  getWordrobeByContact,
})(ContactDetails);
